/* ==========================================================================
   Next Journey Spa — Custom JS (no third-party libraries)
   ========================================================================== */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasIO = "IntersectionObserver" in window;

  /* ------------------------------------------------------------------
     Review content (Reviews Section / node 6-1124)

     ⚠️ PLACEHOLDER COPY. The reviews drawn in Figma were pasted in from a
     different project (an audit firm) and must not ship. These stand-ins are
     spa-appropriate but invented. Replace them with the real Google reviews
     for Next Journey Spa — this array is the single place to do it.
  ------------------------------------------------------------------ */
  var REVIEWS = [
    {
      name: "Rania Saeed",
      role: "Chief Executive Officer",
      company: "Royal Hospitality",
      time: "5 months ago",
      rating: 4.5,
      avatar: "#4338ca",
      body: "The Japanese head spa was unlike anything I've had in Dubai. Every step was explained, nothing was rushed, and I left feeling completely reset. I've already booked my next appointment."
    },
    {
      name: "Omar Al Nuaimi",
      role: "Vice President, Finance",
      company: "Al Basti Advocates",
      time: "8 months ago",
      rating: 5,
      avatar: "#ea580c",
      body: "Booked the Royal Hammam Journey for my wife's birthday. The team looked after every detail from the moment we arrived and she hasn't stopped talking about it since."
    },
    {
      name: "Isabella Martinez",
      role: "Finance Manager",
      company: "Next Journey Spa Dubai",
      time: "a year ago",
      rating: 5,
      avatar: "#0f766e",
      body: "Spotlessly clean, genuinely calming, and the therapists actually listen to what you need. The foot retreat undid weeks of being on my feet."
    },
    {
      name: "David Li",
      role: "Group Financial Controller",
      company: "DPT Agency",
      time: "3 months ago",
      rating: 4,
      avatar: "#b91c1c",
      body: "Excellent full body massage and a beautiful, quiet space. Parking is a little tight in the evenings, but the treatment more than made up for it."
    },
    {
      name: "Aisha Khan",
      role: "Marketing Director",
      company: "Levant Group",
      time: "9 months ago",
      rating: 5,
      avatar: "#7c3aed",
      body: "I came in for the hair fix treatment and the difference after a single session was obvious. Warm, professional, and never once rushed."
    }
  ];

  /* ------------------------------------------------------------------
     Scroll reveals (AOS-style, dependency-free)

     Any [data-aos] element starts hidden in CSS and is revealed when it
     scrolls into view. Direction comes from the attribute value; per-element
     stagger from [data-aos-delay] (ms).
     - One IntersectionObserver drives every element (no per-element polling).
     - Reveals once, then unobserves. GPU-friendly: opacity/transform only.
     - Reduced-motion or no IO support -> everything shown instantly.
  ------------------------------------------------------------------ */
  function initScrollReveal() {
    var els = document.querySelectorAll("[data-aos]");
    if (!els.length) return;

    function revealNow(el) {
      el.classList.add("aos-in");
    }

    if (prefersReduced || !hasIO) {
      Array.prototype.forEach.call(els, revealNow);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = el.getAttribute("data-aos-delay");
          if (delay) el.style.transitionDelay = delay + "ms";
          revealNow(el);
          obs.unobserve(el);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    Array.prototype.forEach.call(els, function (el) {
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Stat counters (Stats band / node 6-846)

     Count up from 0 to the target when the band scrolls into view.
     The markup already contains the final value, so the section is correct
     with JS disabled and reduced-motion users see the value immediately.
  ------------------------------------------------------------------ */
  function initStatCounters() {
    var counters = document.querySelectorAll(".stat__number[data-count]");
    if (!counters.length) return;

    var DURATION = 1800; // ms

    function render(el, value) {
      el.textContent = value + (el.dataset.suffix || "");
    }

    function animate(el) {
      var target = parseInt(el.dataset.count, 10) || 0;
      var startTime = null;

      function step(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / DURATION, 1);
        var eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
        render(el, Math.round(eased * target));
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          render(el, target); // guarantee the exact final value
        }
      }
      window.requestAnimationFrame(step);
    }

    if (prefersReduced || !hasIO) return; // markup already shows the finals

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animate(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    Array.prototype.forEach.call(counters, function (el) {
      render(el, 0); // reset before it comes into view
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Reviews marquee (Reviews Section / node 6-1124)

     Render the cards from REVIEWS, then clone the set once so the CSS
     translateX(-50%) loop is seamless. Clones are aria-hidden and unfocusable.
     Reduced-motion users get a static, horizontally scrollable strip.
  ------------------------------------------------------------------ */
  function initReviewsMarquee() {
    var track = document.querySelector("[data-reviews-track]");
    if (!track || !REVIEWS.length) return;

    // Scroll speed, in pixels per second. The duration is derived from the
    // track's real width so the cards always drift at the same pace no matter
    // how many reviews the array holds.
    var SPEED = 40;

    function escapeHTML(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }

    // 5 stars: full, then a half if the rating has one, then blanks.
    function starsHTML(rating) {
      var out = "";
      for (var i = 1; i <= 5; i++) {
        if (rating >= i) {
          out += '<img src="' + ((window.NJS_ASSETS && window.NJS_ASSETS["star.svg"]) || "star.svg") + '" alt="" width="14" height="13" loading="lazy" />';
        } else if (rating >= i - 0.5) {
          out += '<img src="' + ((window.NJS_ASSETS && window.NJS_ASSETS["star-half.svg"]) || "star-half.svg") + '" alt="" width="14" height="13" loading="lazy" />';
        }
      }
      return out;
    }

    function cardHTML(r) {
      return (
        '<li class="review-card">' +
          '<div class="review-card__head">' +
            '<span class="review-card__avatar" style="--avatar-bg:' + r.avatar + '" aria-hidden="true">' +
              escapeHTML(r.name.charAt(0)) +
              '<span class="review-card__badge">' +
                '<img src="' + ((window.NJS_ASSETS && window.NJS_ASSETS["avatar-google-badge.svg"]) || "avatar-google-badge.svg") + '" alt="" width="16" height="16" loading="lazy" />' +
              "</span>" +
            "</span>" +
            '<span class="review-card__who">' +
              '<span class="review-card__name">' +
                '<span class="review-card__name-text">' + escapeHTML(r.name) + "</span>" +
                '<img src="' + ((window.NJS_ASSETS && window.NJS_ASSETS["verified.svg"]) || "verified.svg") + '" alt="" width="16" height="16" loading="lazy" />' +
              "</span>" +
              '<span class="review-card__role">' + escapeHTML(r.role) + "</span>" +
              '<span class="review-card__time">' + escapeHTML(r.time) + "</span>" +
            "</span>" +
          "</div>" +
          '<div class="review-card__stars" role="img" aria-label="Rated ' + r.rating + ' out of 5">' +
            starsHTML(r.rating) +
          "</div>" +
          '<p class="review-card__body">' + escapeHTML(r.body) + "</p>" +
          '<div class="review-card__foot">' +
            '<p class="review-card__company"><b>Company:</b> ' + escapeHTML(r.company) + "</p>" +
            '<a class="review-card__more" href="#contact">Read more</a>' +
          "</div>" +
        "</li>"
      );
    }

    track.innerHTML = REVIEWS.map(cardHTML).join("");

    // Reduced motion: no auto-scroll. Leave a static, manually scrollable strip.
    if (prefersReduced) {
      track.parentElement.style.overflowX = "auto";
      return;
    }

    // Clone the set once so translateX(-50%) lands exactly on the seam.
    var originals = Array.prototype.slice.call(track.children);
    originals.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      Array.prototype.forEach.call(clone.querySelectorAll("a, button"), function (el) {
        el.setAttribute("tabindex", "-1");
      });
      track.appendChild(clone);
    });

    // Duration = distance travelled (half the doubled track) ÷ speed.
    var distance = track.scrollWidth / 2;
    track.style.setProperty("--marquee-duration", Math.round(distance / SPEED) + "s");

    track.classList.add("is-animated");
  }

  /* ------------------------------------------------------------------
     Mobile navigation

     Not in the Figma design — required for the page to work below 1024px.
     Hamburger toggles a slide-in panel: aria-expanded is kept in sync, Esc
     closes it, focus is trapped while it is open and restored on close.
  ------------------------------------------------------------------ */
  function initMobileNav() {
    var toggle = document.getElementById("nav-toggle");
    var panel = document.getElementById("nav-links");
    var scrim = document.getElementById("nav-scrim");
    if (!toggle || !panel || !scrim) return;

    var lastFocused = null;

    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll("a[href], button:not([disabled])"),
        function (el) { return el.offsetParent !== null; }
      );
    }

    function open() {
      lastFocused = document.activeElement;
      panel.classList.add("is-open");
      scrim.classList.add("is-open");
      scrim.hidden = false;
      toggle.setAttribute("aria-expanded", "true");
      toggle.setAttribute("aria-label", "Close menu");
      document.body.style.overflow = "hidden";

      var first = focusables()[0];
      if (first) first.focus();
    }

    function close() {
      panel.classList.remove("is-open");
      scrim.classList.remove("is-open");
      scrim.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
      document.body.style.overflow = "";

      if (lastFocused) lastFocused.focus();
      else toggle.focus();
    }

    function isOpen() {
      return toggle.getAttribute("aria-expanded") === "true";
    }

    toggle.addEventListener("click", function () {
      if (isOpen()) close();
      else open();
    });

    scrim.addEventListener("click", close);

    // Tapping a link inside the panel navigates and closes it.
    panel.addEventListener("click", function (e) {
      if (e.target.closest("a") && isOpen()) close();
    });

    document.addEventListener("keydown", function (e) {
      if (!isOpen()) return;

      if (e.key === "Escape") {
        close();
        return;
      }

      if (e.key !== "Tab") return;

      // Trap focus inside the panel.
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // Leaving the mobile breakpoint with the panel open would strand the scrim.
    var mq = window.matchMedia("(min-width: 1025px)");
    var onChange = function (e) {
      if (e.matches && isOpen()) close();
    };
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange); // Safari < 14
  }

  /* ------------------------------------------------------------------
     Sticky header

     The design has a second, white/blurred header (node 6-751). It is
     rendered here as the scrolled state of the hero's own nav: add .is-stuck
     once the page has scrolled past the top bar. rAF-throttled — no layout
     thrashing, no work on every scroll event.
  ------------------------------------------------------------------ */
  function initStickyHeader() {
    var header = document.getElementById("site-header");
    if (!header) return;

    var ticking = false;
    var THRESHOLD = 80; // px

    function update() {
      header.classList.toggle("is-stuck", window.scrollY > THRESHOLD);
      ticking = false;
    }

    window.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  /* ------------------------------------------------------------------
     Forms

     Both forms POST nowhere yet (action="#") — see CLAUDE.md TODO 14.
     Until an endpoint exists, validate client-side and report inline.
     No alert(), no dead button.
  ------------------------------------------------------------------ */
  function initForms() {
    var forms = document.querySelectorAll("[data-form]");
    if (!forms.length) return;

    Array.prototype.forEach.call(forms, function (form) {
      var status = form.querySelector("[data-form-status]");

      form.addEventListener("submit", function (e) {
        e.preventDefault();

        var firstInvalid = null;
        var fields = form.querySelectorAll("input, textarea");

        Array.prototype.forEach.call(fields, function (field) {
          var valid = field.checkValidity();
          field.setAttribute("aria-invalid", valid ? "false" : "true");
          if (!valid && !firstInvalid) firstInvalid = field;
        });

        if (firstInvalid) {
          if (status) {
            status.textContent = "Please check the highlighted fields and try again.";
            status.dataset.state = "error";
          }
          firstInvalid.focus();
          return;
        }

        // TODO: POST to the real endpoint once the client provides one.
        if (status) {
          status.textContent =
            "Thank you — your enquiry has been received. We'll be in touch shortly.";
          status.dataset.state = "ok";
        }
        form.reset();
      });
    });
  }

  function init() {
    initScrollReveal();
    initStatCounters();
    initReviewsMarquee();
    initMobileNav();
    initStickyHeader();
    initForms();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
